import React from 'react';

import InsightsComponent from '../../components/Insights/Insights';

const Insights = () => {
  return (
    <>
      <InsightsComponent />
    </>
  );
};

export default Insights;
